module.exports = __webpack_public_path__ + "img/logo.db5af506.png";